export default {
  // ── Common ──────────────────────────────────────────────────────────────
  common: {
    save: 'حفظ',
    cancel: 'إلغاء',
    confirm: 'تأكيد',
    delete: 'حذف',
    edit: 'تعديل',
    close: 'إغلاق',
    loading: 'جاري التحميل…',
    search: 'بحث',
    filter: 'تصفية',
    export: 'تصدير',
    submit: 'إرسال',
    approve: 'موافقة',
    reject: 'رفض',
    view: 'عرض',
    details: 'التفاصيل',
    status: 'الحالة',
    date: 'التاريخ',
    from: 'من',
    to: 'إلى',
    notes: 'ملاحظات',
    actions: 'إجراءات',
    yes: 'نعم',
    no: 'لا',
    all: 'الكل',
    none: 'لا شيء',
    hours: 'ساعات',
    minutes: 'دقائق',
    days: 'أيام',
    na: 'غير متاح',
    noData: 'لا توجد بيانات',
    success: 'نجاح',
    error: 'خطأ',
    warning: 'تحذير',
    refresh: 'تحديث',
    back: 'رجوع',
    next: 'التالي',
    previous: 'السابق',
    page: 'صفحة',
    of: 'من',
    total: 'الإجمالي',
    name: 'الاسم',
    email: 'البريد الإلكتروني',
    phone: 'الهاتف',
    department: 'القسم',
    position: 'المنصب',
    employee: 'الموظف',
    amount: 'المبلغ',
    reason: 'السبب',
    type: 'النوع',
    duration: 'المدة',
    startDate: 'تاريخ البداية',
    endDate: 'تاريخ النهاية',
    createdAt: 'تاريخ الإنشاء',
    updatedAt: 'تاريخ التحديث',
    language: 'اللغة',
    english: 'الإنجليزية',
    arabic: 'العربية',
    pending: 'قيد الانتظار',
    approved: 'موافق عليه',
    rejected: 'مرفوض',
    active: 'نشط',
    inactive: 'غير نشط',
    completed: 'مكتمل',
    open: 'مفتوح',
    closed: 'مغلق',
    system: 'النظام',
    download: 'تحميل',
    upload: 'رفع',
    preview: 'معاينة',
    generate: 'إنشاء',
    reset: 'إعادة تعيين',
    apply: 'تطبيق',
    clear: 'مسح',
    copy: 'نسخ',
    noResults: 'لا توجد نتائج',
    showMore: 'عرض المزيد',
    showLess: 'عرض أقل',
    today: 'اليوم',
    yesterday: 'أمس',
    thisWeek: 'هذا الأسبوع',
    thisMonth: 'هذا الشهر',
    summary: 'ملخص',
    report: 'تقرير',
    description: 'الوصف',
    optional: 'اختياري',
    required: 'مطلوب',
    invalidEmail: 'أدخل عنوان بريد إلكتروني صحيح',
  },

  // ── Auth / Login ─────────────────────────────────────────────────────────
  auth: {
    signIn: 'تسجيل الدخول',
    signOut: 'تسجيل الخروج',
    signingIn: 'جاري تسجيل الدخول…',
    employee: 'موظف',
    admin: 'مدير',
    emailAddress: 'البريد الإلكتروني',
    password: 'كلمة المرور',
    forgotPassword: 'نسيت كلمة المرور؟',
    rememberMe: 'تذكّرني لمدة 30 يوماً',
    employeeSubtitle: 'الوصول إلى لوحة الحضور الخاصة بك',
    adminSubtitle: 'الوصول إلى لوحة التحكم الإدارية',
    loginSuccess: 'تم تسجيل الدخول بنجاح! جاري التحويل…',
    loginFailed: 'فشل تسجيل الدخول. يرجى المحاولة مرة أخرى.',
    unexpectedError: 'حدث خطأ غير متوقع. يرجى المحاولة مرة أخرى.',
    emailRequired: 'البريد الإلكتروني مطلوب',
    passwordRequired: 'كلمة المرور مطلوبة',
    passwordMinLength: 'يجب أن تكون كلمة المرور 3 أحرف على الأقل',
    enterPassword: 'أدخل كلمة المرور',
    allSystemsOperational: 'جميع الأنظمة تعمل',
    resetPassword: 'إعادة تعيين كلمة المرور',
    resetInstructions: 'أدخل بريدك الإلكتروني وسنرسل لك رابط إعادة التعيين.',
    sendLink: 'إرسال الرابط',
    resetLinkSent: 'تم إرسال رابط إعادة التعيين إلى بريدك الإلكتروني!',
    getAndroidApp: 'تحميل تطبيق أندرويد',
    secure: 'آمن',
    encrypted: 'مشفّر',
    protected: 'محمي',
    tagline: 'كل ما يحتاجه فريقك، في مكان واحد.',
    taglineDesc: 'تتبع الحضور الفوري، وإدارة الإجازات، والموافقة على العمل الإضافي، والرواتب كلها موحّدة.',
    featAttendance: 'تتبع الحضور الفوري',
    featAttendanceDesc: 'تسجيل الحضور والانصراف مع التحقق من الموقع والتتبع المباشر.',
    featLeave: 'إدارة الإجازات',
    featLeaveDesc: 'طلب الإجازات والموافقة عليها وتتبعها في سير عمل واحد.',
    featReports: 'التقارير والإحصاءات',
    featReportsDesc: 'اتجاهات الحضور وساعات العمل الإضافي وتوزيعات الأقسام.',
    featPayroll: 'تكامل الرواتب',
    featPayrollDesc: 'خصومات تلقائية وإنشاء كشوف الرواتب بناءً على بيانات الحضور.',
  },

  // ── Navigation ───────────────────────────────────────────────────────────
  nav: {
    // Employee
    dashboard: 'لوحة التحكم',
    attendance: 'الحضور',
    history: 'السجل',
    leaveRequests: 'طلبات الإجازة',
    payslips: 'كشوف الرواتب',
    profile: 'الملف الشخصي',
    faceEnrollment: 'تسجيل الوجه',
    getTheApp: 'تحميل التطبيق',
    overtimeRequests: 'طلبات العمل الإضافي',
    userManual: 'المساعدة والدليل',
    profileSettings: 'إعدادات الملف الشخصي',
    // Short names (mobile)
    home: 'الرئيسية',
    clock: 'الساعة',
    leave: 'إجازة',
    pay: 'الراتب',
    app: 'التطبيق',
    // Admin groups
    overview: 'نظرة عامة',
    workforce: 'القوى العاملة',
    timeTracking: 'تتبع الوقت',
    leaveManagement: 'الإجازات',
    configuration: 'الإعدادات',
    // Admin items
    employees: 'الموظفون',
    payroll: 'الرواتب',
    overtimeClock: 'ساعة العمل الإضافي',
    overtimeManagement: 'إدارة العمل الإضافي',
    shortLeaveSessions: 'جلسات الإجازة القصيرة',
    lateArrivalDebts: 'ديون التأخير',
    leaveManagementAdmin: 'إدارة الإجازات',
    leaveBalances: 'أرصدة الإجازات',
    holidays: 'الإجازات الرسمية',
    reports: 'التقارير',
    departments: 'الأقسام',
    leaveTypes: 'أنواع الإجازات',
    balanceBanks: 'بنوك الأرصدة',
    workingHours: 'ساعات العمل',
    settings: 'الإعدادات',
    autoApproval: 'الموافقة التلقائية',
    locations: 'المواقع',
    liveMap: 'الخريطة المباشرة',
    analytics: 'التحليلات',
    sessions: 'الجلسات',
    adminPortal: 'بوابة المدير',
    employeePortal: 'بوابة الموظف',
  },

  // ── Employee Dashboard ───────────────────────────────────────────────────
  dashboard: {
    welcomeBack: 'مرحباً بعودتك',
    todayOverview: 'نظرة اليوم',
    clockedIn: 'تم تسجيل الحضور',
    clockedOut: 'تم تسجيل الانصراف',
    workingHours: 'ساعات العمل',
    leaveBalance: 'رصيد الإجازة',
    upcomingLeave: 'الإجازة القادمة',
    recentActivity: 'النشاط الأخير',
    quickActions: 'إجراءات سريعة',
    clockIn: 'تسجيل الحضور',
    clockOut: 'تسجيل الانصراف',
    requestLeave: 'طلب إجازة',
    viewPayslip: 'عرض كشف الراتب',
    attendanceSummary: 'ملخص الحضور',
    overtimeSummary: 'ملخص العمل الإضافي',
    presentDays: 'أيام الحضور',
    absentDays: 'أيام الغياب',
    lateDays: 'أيام التأخير',
    leaveDays: 'أيام الإجازة',
    pendingRequests: 'الطلبات المعلّقة',
    thisMonth: 'هذا الشهر',
    noActivity: 'لا يوجد نشاط حديث',
    greetingMorning: 'صباح الخير',
    greetingAfternoon: 'مساء الخير',
    greetingEvening: 'مساء النور',
    notifications: 'الإشعارات',
    noNotifications: 'لا توجد إشعارات',
    markAllRead: 'تحديد الكل كمقروء',
    annualLeave: 'الإجازة السنوية',
    casualLeave: 'الإجازة العارضة',
    sickLeave: 'إجازة مرضية',
    daysRemaining: 'أيام متبقية',
    hoursWorked: 'ساعات العمل',
    overtimeHours: 'ساعات إضافية',
    nextPayslip: 'كشف الراتب القادم',
    lastClockIn: 'آخر تسجيل حضور',
  },

  // ── Attendance ───────────────────────────────────────────────────────────
  attendance: {
    title: 'الحضور',
    clockIn: 'تسجيل الحضور',
    clockOut: 'تسجيل الانصراف',
    leaveIn: 'الخروج المؤقت',
    leaveOut: 'العودة من الخروج المؤقت',
    currentSession: 'الجلسة الحالية',
    sessionDuration: 'مدة الجلسة',
    location: 'الموقع',
    photo: 'الصورة',
    takePhoto: 'التقاط صورة',
    retakePhoto: 'إعادة الالتقاط',
    gps: 'موقع GPS',
    gpsAccuracy: 'دقة GPS',
    gettingLocation: 'جاري تحديد الموقع…',
    locationRequired: 'الموقع مطلوب',
    photoRequired: 'الصورة مطلوبة',
    submitClockIn: 'تأكيد تسجيل الحضور',
    submitClockOut: 'تأكيد تسجيل الانصراف',
    submitLeaveIn: 'تأكيد الخروج المؤقت',
    submitLeaveOut: 'تأكيد العودة',
    leaveOutFirst: 'يجب العودة أولاً',
    onShortLeave: 'في إجازة قصيرة',
    shortLeaveTimer: 'مدة الإجازة القصيرة',
    autoClockOut: 'انصراف تلقائي',
    autoClockOutBanner: 'تم تسجيل الانصراف تلقائياً بواسطة النظام',
    missedClockOut: 'انصراف مفقود',
    overtimeMode: 'وضع العمل الإضافي',
    overtimeActive: 'العمل الإضافي نشط',
    startOvertime: 'بدء العمل الإضافي',
    stopOvertime: 'إيقاف العمل الإضافي',
    history: 'سجل الحضور',
    todayRecord: 'سجل اليوم',
    clockInTime: 'وقت الحضور',
    clockOutTime: 'وقت الانصراف',
    workHours: 'ساعات العمل',
    breakTime: 'وقت الاستراحة',
    lateArrival: 'تأخر الوصول',
    earlyDeparture: 'مغادرة مبكرة',
    approvalStatus: 'حالة الموافقة',
    pending: 'قيد الانتظار',
    approved: 'موافق عليه',
    rejected: 'مرفوض',
    noRecordToday: 'لا يوجد سجل حضور لهذا اليوم',
    attendanceRecords: 'سجلات الحضور',
    filterByDate: 'تصفية حسب التاريخ',
    filterByStatus: 'تصفية حسب الحالة',
    clockInPhoto: 'صورة الحضور',
    clockOutPhoto: 'صورة الانصراف',
    viewOnMap: 'عرض على الخريطة',
    inProgress: 'جارٍ',
    gracePeriod: '(ضمن فترة السماح)',
  },

  // ── Leave Requests ───────────────────────────────────────────────────────
  leave: {
    title: 'طلبات الإجازة',
    newRequest: 'طلب جديد',
    requestLeave: 'طلب إجازة',
    leaveType: 'نوع الإجازة',
    startDate: 'تاريخ البداية',
    endDate: 'تاريخ النهاية',
    numberOfDays: 'عدد الأيام',
    reason: 'السبب',
    attachDocument: 'إرفاق مستند',
    documentRequired: 'المستند مطلوب',
    submitting: 'جاري الإرسال…',
    submitRequest: 'إرسال الطلب',
    myRequests: 'طلبات إجازتي',
    leaveBalance: 'رصيد الإجازة',
    annualLeave: 'إجازة سنوية',
    casualLeave: 'إجازة عارضة',
    sickLeave: 'إجازة مرضية',
    available: 'المتاح',
    used: 'المستخدم',
    pending: 'قيد الانتظار',
    approved: 'موافق عليه',
    rejected: 'مرفوض',
    cancelled: 'ملغى',
    cancelRequest: 'إلغاء الطلب',
    confirmCancel: 'هل أنت متأكد من إلغاء طلب الإجازة؟',
    requestCancelled: 'تم إلغاء طلب الإجازة بنجاح',
    noRequests: 'لا توجد طلبات إجازة',
    uploadDocument: 'رفع المستند',
    removeDocument: 'إزالة المستند',
    viewDocument: 'عرض المستند',
    daysBalance: 'رصيد الأيام',
    requestSubmitted: 'تم إرسال طلب الإجازة بنجاح',
    requestFailed: 'فشل إرسال طلب الإجازة',
    shortLeave: 'إجازة قصيرة',
    halfDay: 'نصف يوم',
    fullDay: 'يوم كامل',
    leaveHistory: 'سجل الإجازات',
    upcoming: 'القادمة',
    past: 'السابقة',
    filterStatus: 'تصفية حسب الحالة',
    selectLeaveType: 'اختر نوع الإجازة',
    balanceSummary: 'ملخص الرصيد',
    expiryDate: 'تاريخ الانتهاء',
    carryOver: 'الترحيل',
    totalAllocated: 'الإجمالي المخصص',
    totalUsed: 'الإجمالي المستخدم',
    remaining: 'المتبقي',
  },

  // ── Overtime ─────────────────────────────────────────────────────────────
  overtime: {
    title: 'طلبات العمل الإضافي',
    newRequest: 'طلب عمل إضافي جديد',
    date: 'التاريخ',
    hours: 'الساعات',
    reason: 'السبب',
    status: 'الحالة',
    pending: 'قيد الانتظار',
    approved: 'موافق عليه',
    rejected: 'مرفوض',
    cancelled: 'ملغى',
    cancelRequest: 'إلغاء الطلب',
    noRequests: 'لا توجد طلبات عمل إضافي',
    requestSubmitted: 'تم إرسال طلب العمل الإضافي بنجاح',
    totalHours: 'إجمالي الساعات',
    estimatedPay: 'الراتب المقدّر',
    actualPay: 'الراتب الفعلي',
    sessionStart: 'بداية الجلسة',
    sessionEnd: 'نهاية الجلسة',
    duration: 'المدة',
    clockIn: 'تسجيل حضور (عمل إضافي)',
    clockOut: 'تسجيل انصراف (عمل إضافي)',
    activeSession: 'جلسة العمل الإضافي النشطة',
    history: 'سجل العمل الإضافي',
    thisMonth: 'هذا الشهر',
    type: 'النوع',
    legacy: 'قديم',
    clockBased: 'قائم على الساعة',
  },

  // ── Payslips ─────────────────────────────────────────────────────────────
  payslips: {
    title: 'كشوف الرواتب',
    period: 'الفترة',
    basicSalary: 'الراتب الأساسي',
    grossPay: 'الراتب الإجمالي',
    netPay: 'صافي الراتب',
    deductions: 'الخصومات',
    additions: 'الإضافات',
    overtimePay: 'راتب العمل الإضافي',
    absentDeduction: 'خصم الغياب',
    lateDeduction: 'خصم التأخير',
    shortLeaveDeduction: 'خصم الإجازة القصيرة',
    earlyDepartureDeduction: 'خصم المغادرة المبكرة',
    manualAdjustment: 'تعديل يدوي',
    status: 'الحالة',
    draft: 'مسودة',
    finalized: 'مكتمل',
    paid: 'مدفوع',
    downloadPDF: 'تحميل PDF',
    viewDetails: 'عرض التفاصيل',
    noPayslips: 'لا توجد كشوف رواتب',
    generatedOn: 'تم الإنشاء في',
    payslipFor: 'كشف راتب لـ',
    companyInfo: 'معلومات الشركة',
    employeeInfo: 'معلومات الموظف',
    salaryBreakdown: 'تفاصيل الراتب',
    deductionBreakdown: 'تفاصيل الخصومات',
    attendanceSummary: 'ملخص الحضور',
    workingDays: 'أيام العمل',
    presentDays: 'أيام الحضور',
    absentDays: 'أيام الغياب',
    lateArrivals: 'حالات التأخير',
    onTimeArrivals: 'حضور في الوقت المحدد',
    hourlyRate: 'الأجر بالساعة',
    monthlyHours: 'ساعات شهرية',
  },

  // ── Profile ──────────────────────────────────────────────────────────────
  profile: {
    title: 'الملف الشخصي',
    personalInfo: 'المعلومات الشخصية',
    firstName: 'الاسم الأول',
    lastName: 'اسم العائلة',
    email: 'البريد الإلكتروني',
    phone: 'الهاتف',
    department: 'القسم',
    position: 'المنصب',
    employeeId: 'رقم الموظف',
    hireDate: 'تاريخ التعيين',
    changePassword: 'تغيير كلمة المرور',
    currentPassword: 'كلمة المرور الحالية',
    newPassword: 'كلمة المرور الجديدة',
    confirmPassword: 'تأكيد كلمة المرور',
    saveChanges: 'حفظ التغييرات',
    updateSuccess: 'تم تحديث الملف الشخصي بنجاح',
    updateFailed: 'فشل تحديث الملف الشخصي',
    passwordChanged: 'تم تغيير كلمة المرور بنجاح',
    passwordMismatch: 'كلمتا المرور غير متطابقتين',
    profilePhoto: 'صورة الملف الشخصي',
    uploadPhoto: 'رفع صورة',
    removePhoto: 'إزالة الصورة',
    salary: 'الراتب',
    joinedOn: 'تاريخ الانضمام',
  },

  // ── History ──────────────────────────────────────────────────────────────
  history: {
    title: 'سجل الحضور',
    filterByMonth: 'تصفية حسب الشهر',
    clockIn: 'تسجيل الحضور',
    clockOut: 'تسجيل الانصراف',
    duration: 'المدة',
    status: 'الحالة',
    location: 'الموقع',
    photo: 'الصورة',
    noHistory: 'لا يوجد سجل حضور',
    export: 'تصدير',
    summary: 'ملخص شهري',
    totalDays: 'إجمالي الأيام',
    presentDays: 'أيام الحضور',
    absentDays: 'أيام الغياب',
    totalHours: 'إجمالي الساعات',
    averageHours: 'متوسط الساعات/اليوم',
    lateArrivals: 'حالات التأخير',
    earlyDepartures: 'حالات المغادرة المبكرة',
    viewDetails: 'عرض التفاصيل',
  },

  // ── Admin Dashboard ───────────────────────────────────────────────────────
  adminDashboard: {
    title: 'لوحة التحكم',
    totalEmployees: 'إجمالي الموظفين',
    presentToday: 'الحاضرون اليوم',
    onLeave: 'في إجازة',
    pendingApprovals: 'بانتظار الموافقة',
    attendanceOverview: 'نظرة على الحضور',
    leaveOverview: 'نظرة على الإجازات',
    overtimeOverview: 'نظرة على العمل الإضافي',
    recentActivity: 'النشاط الأخير',
    quickStats: 'إحصائيات سريعة',
    absentToday: 'الغائبون اليوم',
    lateToday: 'المتأخرون اليوم',
    clockedIn: 'مسجّلو الحضور',
    notClockedIn: 'لم يسجّلوا الحضور',
    pendingLeaves: 'إجازات بانتظار الموافقة',
    pendingOvertime: 'عمل إضافي بانتظار الموافقة',
    thisMonth: 'هذا الشهر',
    totalPayroll: 'إجمالي الرواتب',
    systemStatus: 'حالة النظام',
    autoApprovalOn: 'الموافقة التلقائية مفعّلة',
    autoApprovalOff: 'الموافقة التلقائية معطّلة',
    liveMap: 'الخريطة المباشرة',
    viewAll: 'عرض الكل',
    noActivity: 'لا يوجد نشاط حديث',
    withActiveSessions: 'جلسات نشطة',
    attendanceRate: 'معدل الحضور',
    todayAttendance: 'حضور اليوم',
    workforceSnapshot: 'لمحة عن القوى العاملة',
    activeSessions: 'جلسات نشطة',
    requestsNeedReview: 'طلبات بحاجة للمراجعة',
    actionClockIn: 'سجّل حضوراً',
    actionClockOut: 'سجّل انصرافاً',
    actionBreakStart: 'بدأ استراحة',
    actionBreakEnd: 'انتهى من الاستراحة',
    actionLocationUpdate: 'حدّث الموقع',
    onLeave: 'في إجازة اليوم',
    absentToday: 'غائب',
    lateToday: 'متأخر',
    pendingLeaves: 'طلبات الإجازات المعلّقة',
  },

  // ── Admin Employees ───────────────────────────────────────────────────────
  employees: {
    title: 'الموظفون',
    addEmployee: 'إضافة موظف',
    editEmployee: 'تعديل الموظف',
    deleteEmployee: 'حذف الموظف',
    employeeDetails: 'تفاصيل الموظف',
    searchEmployees: 'البحث عن موظفين…',
    filterByDepartment: 'تصفية حسب القسم',
    filterByStatus: 'تصفية حسب الحالة',
    employeeId: 'رقم الموظف',
    name: 'الاسم',
    email: 'البريد الإلكتروني',
    department: 'القسم',
    position: 'المنصب',
    salary: 'الراتب',
    hireDate: 'تاريخ التعيين',
    status: 'الحالة',
    active: 'نشط',
    inactive: 'غير نشط',
    probationary: 'تحت التجربة',
    actions: 'إجراءات',
    noEmployees: 'لا يوجد موظفون',
    confirmDelete: 'هل أنت متأكد من حذف هذا الموظف؟',
    deleteWarning: 'لا يمكن التراجع عن هذا الإجراء.',
    employeeAdded: 'تم إضافة الموظف بنجاح',
    employeeUpdated: 'تم تحديث الموظف بنجاح',
    employeeDeleted: 'تم حذف الموظف بنجاح',
    totalEmployees: 'إجمالي الموظفين',
    activeEmployees: 'الموظفون النشطون',
    viewProfile: 'عرض الملف الشخصي',
    sendNotification: 'إرسال إشعار',
    resetPassword: 'إعادة تعيين كلمة المرور',
    gender: 'الجنس',
    male: 'ذكر',
    female: 'أنثى',
    nationalId: 'رقم الهوية',
    workingHoursConfig: 'إعداد ساعات العمل',
    probationEnd: 'نهاية التجربة',
    description: 'إدارة حسابات الموظفين وملفاتهم الشخصية وصلاحيات الوصول',
    addEmployeeDesc: 'إنشاء حساب موظف جديد بجميع التفاصيل اللازمة',
    editEmployeeDesc: 'تحديث معلومات الموظف وبيانات اعتماده',
    filterByDepartment: 'جميع الأقسام',
    filterByStatus: 'جميع الحالات',
  },

  // ── Admin Attendance ──────────────────────────────────────────────────────
  adminAttendance: {
    title: 'الحضور',
    pendingRequests: 'الطلبات المعلّقة',
    allRecords: 'جميع السجلات',
    approveRequest: 'الموافقة على الطلب',
    rejectRequest: 'رفض الطلب',
    bulkApprove: 'موافقة جماعية',
    approvalNotes: 'ملاحظات الموافقة',
    rejectionReason: 'سبب الرفض',
    requestDetails: 'تفاصيل الطلب',
    employee: 'الموظف',
    type: 'النوع',
    timestamp: 'الوقت',
    location: 'الموقع',
    photo: 'الصورة',
    gpsAccuracy: 'دقة GPS',
    failedConstraints: 'القيود الفاشلة',
    notes: 'ملاحظات',
    systemGenerated: 'مولّد بواسطة النظام',
    autoClockOut: 'انصراف تلقائي',
    clockIn: 'تسجيل حضور',
    clockOut: 'تسجيل انصراف',
    filterByEmployee: 'تصفية حسب الموظف',
    filterByDate: 'تصفية حسب التاريخ',
    filterByType: 'تصفية حسب النوع',
    noRequests: 'لا توجد طلبات حضور',
    approved: 'موافق عليه',
    rejected: 'مرفوض',
    pending: 'قيد الانتظار',
    viewPhoto: 'عرض الصورة',
    openMap: 'فتح الخريطة',
    description: 'مراقبة وإدارة طلبات حضور الموظفين',
    totalRecords: 'إجمالي السجلات',
    allDepartments: 'جميع الأقسام',
    allStatuses: 'جميع الحالات',
    autoApproved: 'موافقة تلقائية',
    searchPlaceholder: 'الاسم أو الرقم الوظيفي…',
    showing: 'عرض {from}–{to} من {total}',
    rejectRequest: 'رفض طلب الحضور',
    rejectReason: 'أدخل سبباً لرفض هذا الطلب.',
    autoClockOutDesc: 'انتهت فترة السماح بعد ساعات العمل. لم يتخذ الموظف أي إجراء.',
    requestedTime: 'وقت الطلب',
    payrollTimeCapped: 'وقت الراتب (محدود)',
    source: 'المصدر',
    systemAutoClockOut: 'النظام (تسجيل انصراف تلقائي)',
    noAddress: 'لم يُسجّل أي عنوان',
    addNotes: 'أضف ملاحظات…',
    rejectionPlaceholder: 'سبب الرفض…',
    confirmReject: 'تأكيد الرفض',
    unknown: 'غير معروف',
    failedConstraintsTitle: 'فشل الموافقة التلقائية — القيود',
    adminNotesTitle: 'ملاحظات المسؤول',
    by: 'بواسطة',
  },

  // ── Admin Leave ───────────────────────────────────────────────────────────
  adminLeave: {
    title: 'إدارة الإجازات',
    pendingLeaves: 'إجازات بانتظار الموافقة',
    allLeaves: 'جميع الإجازات',
    employee: 'الموظف',
    leaveType: 'نوع الإجازة',
    startDate: 'تاريخ البداية',
    endDate: 'تاريخ النهاية',
    days: 'الأيام',
    reason: 'السبب',
    status: 'الحالة',
    document: 'المستند',
    viewDocument: 'عرض المستند',
    approveLeave: 'الموافقة على الإجازة',
    rejectLeave: 'رفض الإجازة',
    approvalNotes: 'ملاحظات الموافقة',
    rejectionReason: 'سبب الرفض',
    noLeaves: 'لا توجد طلبات إجازة',
    systemGenerated: 'مولّد بواسطة النظام',
    shortLeave: 'إجازة قصيرة',
    filterByEmployee: 'تصفية حسب الموظف',
    filterByStatus: 'تصفية حسب الحالة',
    filterByType: 'تصفية حسب النوع',
    leaveBalances: 'أرصدة الإجازات',
    adjustBalance: 'تعديل الرصيد',
    available: 'المتاح',
    used: 'المستخدم',
    description: 'مراجعة طلبات الإجازة والتصرف بشأنها',
    needsReview: 'بحاجة للمراجعة',
    employeesOut: 'موظف خارج',
    approvedToday: 'موافق عليها اليوم',
    thisSession: 'هذه الجلسة',
    withConflicts: 'بها تعارضات',
    schedulingConflicts: 'تعارضات في الجدول',
    searchPlaceholder: 'الاسم، القسم، الرقم…',
    allTypes: 'جميع الأنواع',
    selected: 'محدد',
    approveAll: 'الموافقة على الكل',
  },

  // ── Admin Payroll ─────────────────────────────────────────────────────────
  payrollPage: {
    prevMonth: 'الشهر السابق',
    nextMonth: 'الشهر التالي',
    prevYear: 'السنة السابقة',
    nextYear: 'السنة التالية',
    thisMonth: 'الشهر الحالي',
    stateNone: 'غير منشأ',
    stateDraft: 'مسودة',
    stateFinalized: 'مكتمل',
    statePaid: 'مدفوع',
    recordsCount: '{n} سجل',
    searchPlaceholder: 'ابحث باسم الموظف أو رقمه',
    allStatuses: 'كل الحالات',
    generateMonth: 'إنشاء رواتب {month}',
    regenerateDrafts: 'إعادة احتساب المسودات',
    finalizeAll: 'إتمام كل المسودات ({n})',
    markAllPaid: 'تحديد الكل كمدفوع ({n})',
    loading: 'جاري تحميل سجلات الرواتب…',
    emptyTitle: 'لا توجد رواتب لشهر {month}',
    emptyDescription: 'أنشئ رواتب هذا الشهر لتظهر هنا.',
    emptyFiltered: 'لا توجد سجلات تطابق البحث أو الحالة المختارة.',
    clearFilters: 'مسح الفلاتر',
    totals: 'المجموع',
    pageOf: 'صفحة {page} من {pages} ({total} سجل)',
    prev: 'السابق',
    next: 'التالي',
    adjustment: 'تعديل',
    missingTitle: '{n} موظف نشط بدون رواتب لشهر {month}',
    generateMissing: 'إنشاء رواتبهم',
    actionView: 'عرض التفاصيل',
    actionRegenerate: 'إعادة الاحتساب',
    actionFinalize: 'إتمام',
    actionMarkPaid: 'تحديد كمدفوع',
    actionDelete: 'حذف',
    generateTitle: 'إنشاء الرواتب',
    generateHint: 'يعاد احتساب المسودات الموجودة لهذا الشهر. الرواتب المكتملة والمدفوعة لا تتغير أبداً.',
    resultTitle: 'رواتب {month}',
    resultCreated: 'أنشئ {n}',
    resultUpdated: 'أعيد احتساب {n}',
    resultSkipped: 'تخطي {n} (مكتمل أو مدفوع مسبقاً)',
    resultErrors: 'فشل {n}',
    resultNothing: 'لا يوجد ما يمكن إنشاؤه.',
    dismiss: 'إغلاق',
    confirm: 'تأكيد',
    confirmFinalizeTitle: 'إتمام الرواتب؟',
    confirmFinalizeOne: 'إتمام راتب {name} لشهر {month}؟ لن يمكن إعادة احتسابه أو حذفه بعد ذلك، وسيتم إشعار الموظف بأن قسيمة الراتب جاهزة.',
    confirmFinalizeAll: 'إتمام {n} مسودة رواتب لشهر {month}؟ لن يمكن إعادة احتسابها أو حذفها بعد ذلك، وسيتم إشعار كل موظف.',
    confirmPaidTitle: 'تحديد كمدفوع؟',
    confirmPaidOne: 'تحديد راتب {name} لشهر {month} كمدفوع؟',
    confirmPaidAll: 'تحديد {n} راتب مكتمل لشهر {month} كمدفوع؟',
    confirmDeleteTitle: 'حذف المسودة؟',
    confirmDeleteOne: 'حذف مسودة راتب {name} لشهر {month}؟',
    confirmRegenerateTitle: 'إعادة احتساب المسودات؟',
    confirmRegenerateAll: 'إعادة احتساب كل مسودات شهر {month} من أحدث بيانات الحضور والإجازات والعمل الإضافي؟ الرواتب المكتملة والمدفوعة لن تتأثر.',
    confirmRegenerateOne: 'إعادة احتساب مسودة راتب {name} لشهر {month}؟',
    finalizedOk: 'تم إتمام الراتب',
    finalizedAllOk: 'تم إتمام {n} راتب',
    paidOk: 'تم تحديد الراتب كمدفوع',
    paidAllOk: 'تم تحديد {n} راتب كمدفوع',
    deletedOk: 'تم حذف المسودة',
    bulkSomeFailed: 'تعذر تحديث {n}',
    loadFailed: 'تعذر تحميل بيانات الرواتب',
    actionFailed: 'تعذر تنفيذ العملية',
    detailsTitle: 'تفاصيل الراتب',
    baseSalary: 'الراتب الأساسي',
    overtimePay: 'أجر العمل الإضافي',
    totalDeductions: 'إجمالي الخصومات',
    netPay: 'صافي الراتب',
    overtimeSessions: 'جلسات العمل الإضافي ({n})، المجموع {h} ساعة',
    total: 'المجموع',
    absentDays: 'أيام الغياب',
    lateArrivals: 'التأخير',
    shortLeaves: 'المغادرات القصيرة',
    earlyDepartures: 'المغادرة المبكرة',
    leaveBalances: 'أرصدة الإجازات ({year})',
    days: 'يوم',
    allocatedPlusCarry: '{a} مخصص + {c} مرحّل',
    generatedBy: 'أنشأه',
    finalizedBy: 'أتمه',
    paidBy: 'دفعه',
    on: 'في',
    auditTrail: 'سجل التغييرات ({n})',
    auditAction: 'الإجراء',
    auditBy: 'بواسطة',
    auditTime: 'الوقت',
    auditSalary: 'تغير صافي الراتب',
    noChange: 'بدون تغيير',
    manualAdjustment: 'تعديل يدوي',
    edit: 'تعديل',
    amount: 'المبلغ',
    reason: 'السبب',
    amountLabel: 'المبلغ ({c})، السالب = خصم',
    amountPlaceholder: 'مثال: 500 أو ‎-200',
    reasonPlaceholder: 'مثال: مكافأة أداء',
    save: 'حفظ',
    cancel: 'إلغاء',
    amountInvalid: 'يجب أن يكون المبلغ رقماً صحيحاً',
    reasonRequired: 'السبب مطلوب',
    adjustmentSaved: 'تم حفظ التعديل',
    auditActions: { generated: 'إنشاء', updated: 'إعادة احتساب', finalized: 'إتمام', unfinalized: 'إعادة فتح', paid: 'دفع', adjustment_added: 'تعديل' },
    detailsFailed: 'تعذر تحميل تفاصيل الراتب',
  },
  adminPayroll: {
    title: 'الرواتب',
    generatePayroll: 'إنشاء الرواتب',
    generateAll: 'إنشاء للكل',
    generateForEmployee: 'إنشاء لموظف محدد',
    period: 'الفترة',
    month: 'الشهر',
    year: 'السنة',
    employee: 'الموظف',
    basicSalary: 'الراتب الأساسي',
    netPay: 'صافي الراتب',
    grossPay: 'الراتب الإجمالي',
    totalDeductions: 'إجمالي الخصومات',
    status: 'الحالة',
    draft: 'مسودة',
    finalized: 'مكتمل',
    paid: 'مدفوع',
    viewDetails: 'عرض التفاصيل',
    downloadPDF: 'تحميل PDF',
    markAsPaid: 'تحديد كمدفوع',
    finalize: 'إتمام',
    manualAdjustment: 'تعديل يدوي',
    adjustmentAmount: 'مبلغ التعديل',
    adjustmentReason: 'سبب التعديل',
    noPayroll: 'لا توجد سجلات رواتب',
    generating: 'جاري الإنشاء…',
    generated: 'تم إنشاء الرواتب بنجاح',
    deductionBreakdown: 'تفاصيل الخصومات',
    overtimePay: 'راتب العمل الإضافي',
    absentDeduction: 'خصم الغياب',
    lateDeduction: 'خصم التأخير',
    shortLeaveDeduction: 'خصم الإجازة القصيرة',
    earlyDepartureDeduction: 'خصم المغادرة المبكرة',
    salaryBased: 'رواتب بناءً على الراتب',
    hourlyBased: 'رواتب بناءً على الساعة',
    comingSoon: 'قريباً',
    totalEmployees: 'إجمالي الموظفين',
    totalPayroll: 'إجمالي الرواتب',
    afterDeductions: 'بعد الخصومات',
    avgSalary: 'متوسط الراتب',
    totalOvertime: 'إجمالي الإضافي',
    year: 'السنة',
    month: 'الشهر',
    employee: 'الموظف',
    period: 'الفترة',
    basicSalary: 'الراتب الأساسي',
    netPay: 'صافي الراتب',
    optionalAll: 'اختياري — فارغ = الكل',
    allEmployees: 'جميع الموظفين',
    description: 'إنشاء وإدارة رواتب الموظفين الشهرية',
  },

  // ── Settings ──────────────────────────────────────────────────────────────
  settings: {
    title: 'الإعدادات',
    companyInfo: 'معلومات الشركة',
    companyName: 'اسم الشركة',
    companyAddress: 'عنوان الشركة',
    companyPhone: 'هاتف الشركة',
    companyWebsite: 'موقع الشركة الإلكتروني',
    companyLogo: 'شعار الشركة',
    uploadLogo: 'رفع الشعار',
    removeLogo: 'إزالة الشعار',
    autoApproval: 'الموافقة التلقائية',
    autoApprovalEnabled: 'الموافقة التلقائية مفعّلة',
    recklessMode: 'الوضع المتساهل',
    recklessModeDesc: 'يتجاهل التحقق من المنطقة والنافذة الزمنية',
    gpsThreshold: 'حد دقة GPS',
    saveSettings: 'حفظ الإعدادات',
    settingsSaved: 'تم حفظ الإعدادات بنجاح',
    systemSettings: 'إعدادات النظام',
    notifications: 'الإشعارات',
    security: 'الأمان',
    language: 'اللغة',
    theme: 'السمة',
    timezone: 'المنطقة الزمنية',
    companyInfoDesc: 'يظهر على جميع ملفات PDF — قسائم الراتب والتقارير والتصدير',
    noLogo: 'لا يوجد شعار',
    uploading: 'جارٍ الرفع…',
    logoHint: 'PNG أو JPG، بحد أقصى 2 ميجابايت. يظهر في رأس PDF إلى جانب اسم الشركة.',
    companyNamePlaceholder: 'أدخل اسم الشركة',
    saveCompany: 'حفظ إعدادات الشركة',
    currencyConfig: 'إعدادات العملة',
    currencyDesc: 'حدد العملة التي تُستخدم في النظام لعرض الرواتب والمبالغ المالية',
    systemCurrency: 'عملة النظام',
    currencyUpdated: 'تم تحديث العملة بنجاح!',
    additionalSettings: 'إعدادات إضافية',
    additionalSettingsDesc: 'ستتوفر المزيد من إعدادات النظام هنا',
    additionalSettingsHint: 'يمكن تهيئة ساعات العمل والموافقة التلقائية والإعدادات الأخرى في أقسامها المخصصة.',
  },

  // ── Notifications ─────────────────────────────────────────────────────────
  notifications: {
    title: 'الإشعارات',
    markAsRead: 'تحديد كمقروء',
    markAllRead: 'تحديد الكل كمقروء',
    noNotifications: 'لا توجد إشعارات',
    leaveApproved: 'تم قبول طلب الإجازة',
    leaveRejected: 'تم رفض طلب الإجازة',
    leaveSubmitted: 'تم تقديم طلب إجازة جديد',
    overtimeApproved: 'تم قبول طلب العمل الإضافي',
    overtimeRejected: 'تم رفض طلب العمل الإضافي',
    attendanceApproved: 'تم الموافقة على الحضور',
    attendanceRejected: 'تم رفض الحضور',
    payslipReady: 'كشف راتبك جاهز',
    viewAll: 'عرض الكل',
  },

  // ── Get the App ────────────────────────────────────────────────────────────
  getApp: {
    title: 'تحميل التطبيق',
    subtitle: 'حمّل تطبيق ExoTrack للأندرويد',
    downloadApk: 'تحميل APK',
    version: 'الإصدار',
    fileSize: 'حجم الملف',
    requirements: 'المتطلبات',
    howToInstall: 'كيفية التثبيت',
    step1: 'تحميل ملف APK',
    step2: 'السماح بالتثبيت من مصادر غير معروفة',
    step3: 'فتح الملف المحمّل والتثبيت',
    step4: 'تشغيل ExoTrack وتسجيل الدخول',
    features: 'مميزات الجوال',
    clockInOut: 'تسجيل الحضور/الانصراف مع GPS والصورة',
    requestLeave: 'طلب إجازة في أي وقت',
    notifications: 'إشعارات فورية',
    viewPayslips: 'عرض كشوف الرواتب',
  },

  // ── Sign out confirmation ─────────────────────────────────────────────────
  signOut: {
    title: 'تسجيل الخروج',
    message: 'هل أنت متأكد من تسجيل الخروج؟',
    confirm: 'تسجيل الخروج',
    cancel: 'إلغاء',
  },

  // ── Landing Page ──────────────────────────────────────────────────────────
  landing: {
    heroTitle: 'نظام ذكي للموارد البشرية والرواتب',
    heroSubtitle: 'مصمّم للفرق العصرية',
    heroDesc: 'تتبع الحضور الفوري، وإدارة الإجازات الذكية، والموافقة على العمل الإضافي، والرواتب الآلية — كلها في منصة واحدة.',
    getStarted: 'ابدأ الآن',
    learnMore: 'اعرف أكثر',
    featuresTitle: 'كل ما تحتاجه',
    featuresSubtitle: 'منصة HR متكاملة لفريقك',
    feat1Title: 'تتبع الحضور',
    feat1Desc: 'تسجيل الحضور والانصراف مع التحقق من GPS والتصوير ومراقبة الموقع المباشر.',
    feat2Title: 'إدارة الإجازات',
    feat2Desc: 'طلبات الإجازة المبسّطة مع سير الموافقة وتتبع الرصيد التلقائي.',
    feat3Title: 'التحكم في العمل الإضافي',
    feat3Desc: 'جلسات عمل إضافي قائمة على الساعة مع معاينة التكلفة وتكامل الرواتب.',
    feat4Title: 'أتمتة الرواتب',
    feat4Desc: 'خصومات تلقائية للغياب والتأخير والمغادرة المبكرة.',
    feat5Title: 'التقارير والتحليلات',
    feat5Desc: 'تقارير مفصّلة قابلة للتصدير إلى PDF وExcel وCSV.',
    feat6Title: 'تطبيق الجوال',
    feat6Desc: 'تطبيق أندرويد أصلي للموظفين لتسجيل الحضور في أي مكان.',
    ctaTitle: 'هل أنت جاهز للبدء؟',
    ctaDesc: 'سجّل دخولك للوصول إلى المنصة الكاملة.',
    signIn: 'تسجيل الدخول',
    footerRights: 'جميع الحقوق محفوظة.',
    poweredBy: 'بتقنية Exodus Software',
    systemOperational: 'جميع الأنظمة تعمل',
  },

  // ── Employee Dashboard (extended) ─────────────────────────────────────────
  empDashboard: {
    loading: 'جارٍ تحميل لوحة التحكم…',
    online: 'متصل',
    offline: 'غير متصل',
    appBannerTitle: 'تطبيق ExoTrack لأندرويد متاح الآن!',
    appBannerDesc: 'سجّل حضورك، واطلب إجازة، واحصل على إشعارات مباشرة من هاتفك.',
    getApp: 'احصل على التطبيق',
    getIt: 'احصل عليه',
    since: 'منذ',
    started: 'بدأ',
    lastWorked: 'آخر عمل',
    readyToStart: 'هل أنت مستعد لبدء يومك',
    today: 'اليوم',
    thisWeek: 'هذا الأسبوع',
    clockOut: 'تسجيل الخروج',
    clockIn: 'تسجيل الدخول',
    dailySummary: 'ملخص اليوم',
    hoursWorked: 'ساعات العمل',
    breaks: 'الاستراحات',
    location: 'الموقع',
    viewHistory: 'عرض السجل',
    leaveBalance: 'رصيد الإجازات',
    availableDays: 'الأيام المتاحة',
    annualLeave: 'إجازة سنوية',
    sickLeave: 'إجازة مرضية',
    personal: 'شخصية',
    requestLeave: 'طلب إجازة',
    thisMonth: 'هذا الشهر',
    workStatistics: 'إحصائيات العمل',
    totalHours: 'إجمالي الساعات',
    daysWorked: 'أيام العمل',
    avgPerDay: 'المتوسط / اليوم',
    ofMonthlyTarget: '٪ من الهدف الشهري',
    recentAttendance: 'الحضور الأخير',
    viewAll: 'عرض الكل',
    noAttendanceYet: 'لا توجد سجلات حضور بعد',
    clockInNow: 'سجّل دخولك الآن',
    inProgress: 'جارٍ',
    allCaughtUp: 'أنت على اطلاع بكل شيء',
    working: 'يعمل',
    days: 'أيام',
  },

  // ── Employee Attendance (extended) ────────────────────────────────────────
  empAttendance: {
    regularClock: 'ساعة عادية',
    overtimeClock: 'ساعة عمل إضافي',
    workingHours: 'ساعات العمل',
    standardHours: 'ساعات العمل المعيارية',
    standardHoursValue: '٨:٠٠ صباحاً – ٥:٠٠ مساءً',
    weeklyHours: 'ساعات أسبوعية',
    weeklyHoursValue: '٤٠ ساعة',
    quickLinks: 'روابط سريعة',
    viewHistory: 'عرض السجل',
    leaveRequests: 'طلبات الإجازة',
    overtimeActive: 'العمل الإضافي نشط',
    overtimePending: 'العمل الإضافي في انتظار الموافقة',
    overtimeUnderReview: 'العمل الإضافي قيد المراجعة',
    currentlyWorking: 'يعمل حالياً',
    pendingApproval: 'في انتظار الموافقة',
    workCompleted: 'اكتمل العمل',
    notClockedIn: 'لم يتم تسجيل الدخول',
    remaining: 'متبقٍ',
    timerExpired: 'انتهى الوقت',
    rateMultiplier: 'معامل المعدل',
  },

  // ── Employee History (extended) ───────────────────────────────────────────
  empHistory: {
    regularAttendance: 'الحضور العادي',
    overtime: 'العمل الإضافي',
    thisWeek: 'هذا الأسبوع',
    thisMonth: 'هذا الشهر',
    thisQuarter: 'هذا الربع',
    totalSessions: 'إجمالي الجلسات',
    avgDaily: 'يومي متوسط',
    dateRange: 'نطاق التاريخ',
    allRecords: 'كل السجلات',
    completed: 'مكتمل',
    inProgress: 'جارٍ',
    customRange: 'نطاق مخصص',
    resetFilters: 'إعادة تعيين الفلاتر',
    startDate: 'تاريخ البداية',
    endDate: 'تاريخ النهاية',
    workSessions: 'جلسات العمل',
    overtimeSessions: 'جلسات العمل الإضافي',
    showing: 'عرض',
    of: 'من',
    sessions: 'جلسات',
    export: 'تصدير',
    date: 'التاريخ',
    clockIn: 'تسجيل الدخول',
    clockOut: 'تسجيل الخروج',
    hours: 'الساعات',
    status: 'الحالة',
    actions: 'الإجراءات',
    viewDetails: 'عرض التفاصيل',
    noSessionsFound: 'لم يتم العثور على جلسات عمل',
    adjustFilters: 'حاول تعديل معايير الفلتر',
    sessionDetails: 'تفاصيل جلسة العمل',
    timeDetails: 'تفاصيل الوقت',
    notRecorded: 'غير مسجّل',
    clockedOutBySystem: 'تم تسجيل الخروج بواسطة النظام',
    timeCapped: 'تم تحديد الوقت',
    reason: 'السبب:',
    payrollFrom: 'الوقت المحتسب في الراتب من',
    payrollUntil: 'الوقت المحتسب في الراتب حتى',
    noClockIn: 'هذه الجلسة لها وقت خروج لكن لا يوجد وقت دخول مقابل.',
    stillInProgress: 'هذه الجلسة لا تزال جارية — لم يتم تسجيل وقت الخروج بعد.',
    incompleteRecords: 'هذه الجلسة تحتوي على سجلات وقت غير مكتملة.',
  },

  // ── Employee Leave (extended) ─────────────────────────────────────────────
  empLeave: {
    yourBalance: 'رصيد إجازاتك',
    newRequest: 'طلب جديد',
    daysLeft: 'أيام متبقية',
    usedOf: 'مستخدم من',
    total: 'المجموع',
    usage: 'الاستخدام',
    percentUsed: '٪ مستخدم',
    noBalanceAvailable: 'لا يوجد رصيد متاح',
    newLeaveRequest: 'طلب إجازة جديد',
    newLeaveSubtitle: 'تقدّم بطلب إجازة أو وقت طوارئ أو ظروف خاصة',
    pending: 'في الانتظار',
    approved: 'موافق عليه',
    thisMonth: 'هذا الشهر',
    totalRequests: 'إجمالي الطلبات',
    leaveHistory: 'سجل طلبات الإجازة',
    requests: 'طلبات',
    allStatus: 'كل الحالات',
    allTypes: 'كل الأنواع',
    allTime: 'كل الأوقات',
    reset: 'إعادة تعيين',
    noLeaveFound: 'لم يتم العثور على طلبات إجازة',
    noLeaveYet: 'لم تقدّم أي طلبات إجازة بعد.',
    submitFirst: 'قدّم طلبك الأول',
    day: 'يوم',
    days: 'أيام',
    noReasonProvided: 'لم يتم تقديم سبب',
    submitted: 'مُقدَّم',
    viewDetails: 'عرض التفاصيل',
    cancel: 'إلغاء',
    leaveDetails: 'تفاصيل طلب الإجازة',
    startDate: 'تاريخ البداية',
    endDate: 'تاريخ النهاية',
    duration: 'المدة',
    reason: 'السبب',
    reviewInfo: 'معلومات المراجعة',
    reviewedBy: 'تمت المراجعة بواسطة',
    reviewDate: 'تاريخ المراجعة',
    reviewNotes: 'ملاحظات المراجعة',
    cancelRequest: 'إلغاء الطلب',
    close: 'إغلاق',
    annual: 'سنوية',
    sick: 'مرضية',
    personal: 'شخصية',
  },

  // ── Employee Overtime (extended) ──────────────────────────────────────────
  empOvertime: {
    currentSession: 'جلسة العمل الإضافي الحالية',
    startedAt: 'بدأت في',
    on: 'في',
    duration: 'المدة:',
    status: 'الحالة:',
    rateMultiplier: 'معامل المعدل',
    thisMonth: 'هذا الشهر',
    pendingRequests: 'الطلبات المعلقة',
    allStatus: 'كل الحالات',
    fromDate: 'من تاريخ',
    toDate: 'إلى تاريخ',
    apply: 'تطبيق',
    clear: 'مسح',
    myRequests: 'طلبات العمل الإضافي',
    requestOvertime: 'طلب عمل إضافي',
    loading: 'جارٍ تحميل طلبات العمل الإضافي…',
    noRequestsFound: 'لم يتم العثور على طلبات عمل إضافي',
    submitFirst: 'قدّم طلب عمل إضافي للبدء',
    scheduled: 'مجدوَل',
    realtime: 'وقت فعلي',
    urgent: 'عاجل',
    high: 'عالٍ',
    hRequested: 'ساعة مطلوبة',
    approvedOn: 'موافق عليه في',
    rejected: 'مرفوض:',
    showing: 'عرض',
    of: 'من',
    previous: 'السابق',
    next: 'التالي',
    requestModal: 'طلب عمل إضافي',
    date: 'التاريخ',
    startTime: 'وقت البداية',
    endTime: 'وقت النهاية',
    requestSummary: 'ملخص الطلب',
    type: 'النوع:',
    priorityLevel: 'مستوى الأولوية',
    low: 'منخفض',
    normal: 'عادي',
    highPriority: 'عالٍ',
    urgentPriority: 'عاجل',
    reasonLabel: 'سبب العمل الإضافي',
    reasonPlaceholder: 'يرجى تقديم سبب واضح لطلب العمل الإضافي…',
    justification: 'مبرر إضافي (اختياري)',
    justificationPlaceholder: 'أي تفاصيل إضافية أو مبرر تجاري…',
    submitRequest: 'تقديم الطلب',
    submitting: 'جارٍ التقديم…',
    detailsTitle: 'تفاصيل طلب العمل الإضافي',
    requestInfo: 'معلومات الطلب',
    dateLabel: 'التاريخ:',
    startLabel: 'البداية:',
    endLabel: 'النهاية:',
    durationLabel: 'المدة:',
    typeLabel: 'النوع:',
    modeLabel: 'الوضع:',
    preScheduled: 'مُجدوَل مسبقاً',
    realtimeClock: 'ساعة وقت فعلي',
    rejectionDetails: 'تفاصيل الرفض',
    approvalDetails: 'تفاصيل الموافقة',
    onLabel: 'في:',
    rejectionReason: 'سبب الرفض:',
    actualTimeWorked: 'الوقت الفعلي للعمل',
    actualHours: 'الساعات الفعلية:',
    cost: 'التكلفة:',
  },

  // ── Employee Payslips (extended) ──────────────────────────────────────────
  empPayslips: {
    year: 'السنة',
    allYears: 'كل السنوات',
    month: 'الشهر',
    allMonths: 'كل الأشهر',
    allStatuses: 'كل الحالات',
    finalized: 'مكتمل',
    paid: 'مدفوع',
    draft: 'مسودة',
    clear: 'مسح',
    filtered: 'مفلتر',
    payslipsFound: 'قسيمة راتب',
    netPay: 'صافي الراتب',
    paidOn: 'مدفوع في',
    noResults: 'لم يتم العثور على نتائج',
    noPayslips: 'لا توجد قسائم راتب بعد',
    adjustFilters: 'حاول تعديل الفلاتر.',
    noRecordsYet: 'لم يتم إنشاء أي سجلات رواتب بعد.',
    clearFilters: 'مسح الفلاتر',
  },

  // ── Employee PayslipDetail (extended) ─────────────────────────────────────
  empPayslipDetail: {
    backToPayslips: '← العودة إلى قسائم الراتب',
    receipt: 'إيصال',
    generating: 'جارٍ الإنشاء…',
    downloadPDF: 'تنزيل PDF',
    grossPay: 'الراتب الإجمالي',
    totalDeductions: 'إجمالي الخصومات',
    netPay: 'صافي الراتب',
    earnings: 'الأرباح',
    baseSalary: 'الراتب الأساسي',
    workingHoursPerMonth: 'ساعات العمل / الشهر:',
    hourlyRate: 'الأجر بالساعة:',
    hr: 'ساعة',
    overtimePay: 'أجر العمل الإضافي',
    hours: 'ساعات',
    manualAdjustment: 'تعديل يدوي',
    deductions: 'الخصومات',
    absentDays: 'أيام الغياب',
    lateArrivals: 'التأخيرات',
    shortLeave: 'الإجازة القصيرة',
    earlyDeparture: 'المغادرة المبكرة',
    attendanceStats: 'إحصائيات الحضور',
    workingDays: 'أيام العمل',
    daysAttended: 'الأيام المحضورة',
    daysAbsent: 'أيام الغياب',
    onTimeArrivals: 'وصول في الوقت',
    hoursWorked: 'ساعات العمل',
    expectedHours: 'الساعات المتوقعة',
    overtimeHours: 'ساعات العمل الإضافي',
    leaveBalances: 'أرصدة الإجازات',
    days: 'أيام',
    percentRemaining: '٪ متبقٍ',
    allocated: 'مخصص:',
    used: 'مستخدم:',
    pending: 'معلق:',
    paymentInfo: 'معلومات الدفع',
    paymentMethod: 'طريقة الدفع',
    bankAccount: 'الحساب البنكي',
    paymentDate: 'تاريخ الدفع',
    paidBy: 'دفع بواسطة',
    auditTrail: 'سجل المراجعة',
    generated: 'مُنشأ:',
    by: 'بواسطة',
    finalized: 'مكتمل:',
    notes: 'ملاحظات:',
  },

  // ── Employee Profile (extended) ───────────────────────────────────────────
  empProfile: {
    loading: 'جارٍ تحميل الملف الشخصي…',
    errorLoading: 'خطأ في تحميل الملف الشخصي',
    name: 'الاسم',
    email: 'البريد الإلكتروني',
    phone: 'الهاتف',
    address: 'العنوان',
    phonePlaceholder: 'مثال: +970 59 123 4567',
    emergencyName: 'اسم جهة الاتصال في حالات الطوارئ',
    emergencyPhone: 'هاتف جهة الاتصال في حالات الطوارئ',
    accountSecurity: 'الحساب والأمان',
    joinDate: 'تاريخ الانضمام',
    lastLogin: 'آخر تسجيل دخول',
    never: 'أبداً',
    lastUpdated: 'آخر تحديث',
    accountStatus: 'حالة الحساب',
    active: 'نشط',
    inactive: 'غير نشط',
    password: 'كلمة المرور',
    lastChanged: 'آخر تغيير',
    changePassword: 'تغيير كلمة المرور',
    twoFactor: 'المصادقة الثنائية',
    twoFactorDesc: 'أمان إضافي لحسابك',
    comingSoon: 'قريباً',
    enable2fa: 'تفعيل المصادقة الثنائية',
    twoFactorNotice: 'ستتوفر المصادقة الثنائية في تحديث مستقبلي',
    workInfo: 'معلومات العمل',
    department: 'القسم',
    manager: 'المدير',
    position: 'المنصب',
    status: 'الحالة',
    hireDate: 'تاريخ التعيين',
    canWorkField: 'يمكنه العمل ميدانياً',
    yes: 'نعم',
    no: 'لا',
    leaveInfo: 'معلومات الإجازات',
    used: 'مستخدم',
    daysRemaining: 'أيام متبقية',
    editProfile: 'تعديل الملف الشخصي',
    saveChanges: 'حفظ التغييرات',
    saving: 'جارٍ الحفظ…',
    personalInfo: 'المعلومات الشخصية',
    contact: 'التواصل',
  },

  // ── Employee GetTheApp (extended) ─────────────────────────────────────────
  empGetApp: {
    title: 'احصل على تطبيق ExoTrack',
    subtitle: 'سجّل الحضور، واطلب إجازة، واطّلع على قسائم الراتب من هاتفك',
    back: 'رجوع',
    downloadAndroid: 'تنزيل لأندرويد',
    downloadBtn: 'تنزيل ExoTrack الإصدار ',
    version: 'الإصدار',
    size: 'الحجم',
    sizeValue: '٦٥ ميجابايت',
    requires: 'المتطلبات',
    requiresValue: 'أندرويد 7.0 أو أحدث',
    checksum: 'بصمة SHA-256',
    scanQr: 'على جهاز كمبيوتر؟ امسح بهاتفك',
    qrAlt: 'رمز QR للتنزيل',
    qrHint: 'وجّه كاميرا هاتفك نحو الرمز، يبدأ التنزيل على الهاتف حيث يجب تثبيت التطبيق.',
    howToInstall: 'كيفية التثبيت',
    step1Title: 'نزّل ملف APK على هاتفك الأندرويد',
    step1Desc: 'استخدم الزر أعلاه (أو امسح رمز QR من الكمبيوتر). سيظهر الملف في مجلد التنزيلات.',
    step2Title: 'افتح الملف المنزَّل',
    step2Desc: 'اضغط على إشعار التنزيل، أو ابحث عن ExoTrack.apk في تطبيق الملفات / التنزيلات واضغط عليه.',
    step3Title: 'اسمح بالتثبيت من هذا المصدر إذا طُلب منك',
    step3Desc: 'في المرة الأولى، يطلب أندرويد السماح لمتصفحك بتثبيت التطبيقات. اضغط على الإعدادات، فعّل "السماح من هذا المصدر"، ثم ارجع.',
    step4Title: 'ثبّت رغم تحذير Play Protect',
    step4Desc: 'إذا أظهر Google Play Protect تحذير "تطبيق غير معروف"، اختر "تثبيت على أي حال"، يظهر هذا لأي تطبيق ليس من Play Store.',
    step5Title: 'افتح ExoTrack وسجّل دخولك',
    step5Desc: 'استخدم نفس البريد الإلكتروني وكلمة المرور المستخدمَين في هذا الموقع.',
  },

  // ── Reports ────────────────────────────────────────────────────────────────
  reports: {
    title: 'التقارير',
    generateReport: 'إنشاء تقرير',
    reportType: 'نوع التقرير',
    scope: 'النطاق',
    individual: 'فردي',
    general: 'عام (جميع الموظفين)',
    selectEmployee: 'اختر موظفاً',
    dateRange: 'نطاق التاريخ',
    exportPDF: 'تصدير PDF',
    exportExcel: 'تصدير Excel',
    exportCSV: 'تصدير CSV',
    attendance: 'تقرير الحضور',
    leave: 'تقرير الإجازات',
    overtime: 'تقرير العمل الإضافي',
    shortLeave: 'تقرير الإجازات القصيرة',
    lateArrival: 'تقرير التأخير',
    payroll: 'تقرير الرواتب',
    noData: 'لا توجد بيانات للتقرير',
    generating: 'جاري إنشاء التقرير…',
  },

  // ── Short Leave Sessions ───────────────────────────────────────────────────
  shortLeaveSessions: {
    title: 'جلسات الإجازة القصيرة',
    description: 'تتبع أحداث تسجيل الدخول والخروج للإجازات القصيرة للموظفين',
    sessions: 'جلسات',
    totalSessions: 'إجمالي الجلسات',
    from: 'من',
    to: 'إلى',
    status: 'الحالة',
    allStatuses: 'جميع الحالات',
    active: 'نشط',
    completed: 'مكتمل',
    expired: 'منتهي',
    apply: 'تطبيق',
    reset: 'إعادة تعيين',
    noSessions: 'لا توجد جلسات إجازة قصيرة للفترة المحددة',
    employee: 'الموظف',
    date: 'التاريخ',
    leaveIn: 'دخول الإجازة',
    leaveOut: 'خروج الإجازة',
    duration: 'المدة',
    photos: 'الصور',
    stillOut: 'لا يزال خارجاً',
    inProgress: 'قيد التنفيذ',
    grace: 'فترة سماح ✓',
    viewDetail: 'عرض التفاصيل',
    sessionDetail: 'تفاصيل الجلسة',
    gracePeriod: 'فترة سماح — لا خصم',
    leaveInPanel: 'دخول الإجازة',
    leaveOutPanel: 'خروج الإجازة',
    time: 'الوقت',
    system: 'نظام',
    auto: 'تلقائي',
    locationNotRecorded: 'الموقع غير مسجل',
    noPhoto: 'لا توجد صورة',
    openFullMap: 'فتح الخريطة الكاملة ↗',
    stillOutBadge: 'لا يزال خارجاً — لم يعد بعد',
    close: 'إغلاق',
    page: 'صفحة',
  },

  // ── Late Arrival Debts ────────────────────────────────────────────────────
  lateArrivalDebts: {
    title: 'ديون التأخر في الوصول',
    description: 'تتبع حالات التأخر في الوصول وديون الوقت (فترة السماح: 8:00 صباحاً – 8:10 صباحاً)',
    export: 'تصدير',
    refresh: 'تحديث',
    totalOccurrences: 'إجمالي الحالات',
    employeesAffected: 'الموظفون المتأثرون',
    totalHoursLate: 'إجمالي ساعات التأخر',
    avgMinutesLate: 'متوسط دقائق التأخر',
    perOccurrence: 'لكل حالة',
    excused: 'معفو عنه',
    startDate: 'تاريخ البداية',
    endDate: 'تاريخ النهاية',
    status: 'الحالة',
    allStatuses: 'جميع الحالات',
    autoApproved: 'موافق عليه تلقائياً',
    pendingReview: 'قيد المراجعة',
    search: 'بحث',
    searchPlaceholder: 'اسم الموظف أو الرمز…',
    reset: 'إعادة تعيين',
    topOffenders: 'الأكثر تأخراً — أعلى 5',
    byDepartment: 'حسب القسم',
    employeesAffectedLabel: 'موظف متأثر',
    noLateArrivals: 'لا توجد حالات تأخر — جرّب تعديل المرشحات أو نطاق التاريخ.',
    date: 'التاريخ',
    employee: 'الموظف',
    department: 'القسم',
    clockIn: 'وقت الحضور',
    lateDuration: 'مدة التأخر',
    grace: 'السماح',
    by: 'بواسطة',
    excuse: 'إعفاء',
    removeExcuse: 'إزالة الإعفاء',
    viewDetails: 'عرض التفاصيل',
    delete: 'حذف',
    pageOf: 'صفحة {page} من {total} ({count} إجمالي)',
    excuseLateArrival: 'إعفاء التأخر في الوصول',
    excuseReason: 'سبب الإعفاء',
    excuseReasonRequired: 'سبب الإعفاء *',
    additionalNotes: 'ملاحظات إضافية',
    notesPlaceholder: 'ملاحظات إضافية اختيارية…',
    cancel: 'إلغاء',
    submitExcuse: 'تطبيق الإعفاء',
    lateArrivalDetails: 'تفاصيل التأخر في الوصول',
    timeDetails: 'تفاصيل الوقت',
    scheduledStart: 'وقت البداية المجدول',
    gracePeriodEnd: 'نهاية فترة السماح',
    actualClockIn: 'وقت الحضور الفعلي',
    lateDurationTitle: 'مدة التأخر',
    excuseInfo: 'معلومات الإعفاء',
    excuseReasonLabel: 'سبب الإعفاء',
    excusedBy: 'أُعفي بواسطة',
    excusedAt: 'تاريخ الإعفاء',
    notes: 'ملاحظات',
    minutes: 'دقيقة',
    totalHours: 'ساعة إجمالي',
    of: 'من',
    confirmRemoveExcuse: 'هل أنت متأكد من إزالة الإعفاء من هذا التأخر؟',
    confirmDelete: 'هل أنت متأكد من حذف سجل التأخر لـ {name}؟',
  },

  // ── Holiday Management ────────────────────────────────────────────────────
  holidays: {
    title: 'إدارة العطل',
    description: 'إدارة العطل السنوية وسياسات إجازات الشركة',
    export: 'تصدير',
    import: 'استيراد',
    addHoliday: 'إضافة عطلة',
    year: 'السنة',
    totalHolidays: 'إجمالي العطل',
    upcoming: 'القادمة',
    longWeekends: 'عطل نهاية الأسبوع الطويلة',
    allCategories: 'الكل',
    holidaysFor: 'العطل لعام',
    noHolidays: 'لا توجد عطل',
    noHolidaysDesc: 'أضف عطلة أو عدّل المرشحات.',
    editHoliday: 'تعديل العطلة',
    deleteHoliday: 'حذف العطلة',
    holidayName: 'اسم العطلة',
    holidayDate: 'التاريخ',
    category: 'الفئة',
    description: 'الوصف',
    optional: '(اختياري)',
    isRecurring: 'متكررة سنوياً',
    affectsPayroll: 'تؤثر على الراتب',
    addHolidayTitle: 'إضافة عطلة جديدة',
    editHolidayTitle: 'تعديل العطلة',
    confirmDelete: 'هل أنت متأكد من حذف هذه العطلة؟',
    save: 'حفظ',
    cancel: 'إلغاء',
  },

  // ── Working Hours Config ──────────────────────────────────────────────────
  workingHours: {
    title: 'إعداد ساعات العمل',
    description: 'تهيئة ساعات العمل القياسية وسياسات العمل الإضافي والإعدادات الخاصة بالأقسام',
    refresh: 'تحديث',
    saveChanges: 'حفظ التغييرات',
    saving: 'جاري الحفظ…',
    neverSaved: 'لم يُحفظ بعد',
    updated: 'تم التحديث',
    systemSettings: 'إعدادات النظام',
    timezone: 'المنطقة الزمنية',
    autoClockOut: 'الإنهاء التلقائي',
    enableAutoClockOut: 'تفعيل الإنهاء التلقائي',
    enableAutoClockOutDesc: 'إنهاء دوام الموظفين في نهاية ساعات العمل',
    gracePeriod: 'فترة السماح (دقائق)',
    gracePeriodDesc: 'السماح للموظفين بالعمل بعد الساعات القياسية قبل الإنهاء التلقائي',
    weeklySchedule: 'الجدول الأسبوعي',
    scheduleNote: 'تهيئة أيام وساعات العمل القياسية لكل يوم في الأسبوع',
    workDay: 'يوم عمل',
    startTime: 'وقت البداية',
    endTime: 'وقت النهاية',
    breakDuration: 'مدة الاستراحة',
    overtime: 'إعدادات العمل الإضافي',
    overtimeNote: 'إعدادات جلسات العمل الإضافي',
    maxOvertimeHours: 'الحد الأقصى للعمل الإضافي (ساعات/يوم)',
    minOvertimeMinutes: 'الحد الأدنى للعمل الإضافي (دقائق)',
    overtimeRateMultiplier: 'معامل الأجر',
    requireApproval: 'يتطلب موافقة مسبقة',
    configSaved: 'تم حفظ إعداد ساعات العمل',
    configSaveFailed: 'فشل في حفظ الإعداد',
  },

  // ── Department Management ─────────────────────────────────────────────────
  departments: {
    title: 'إدارة الأقسام',
    description: 'إدارة الأقسام وتعيين المدراء وتهيئة ساعات العمل',
    addDepartment: 'إضافة قسم',
    search: 'بحث',
    searchPlaceholder: 'البحث في الأقسام…',
    status: 'الحالة',
    allDepartments: 'جميع الأقسام',
    activeOnly: 'النشطة فقط',
    inactiveOnly: 'غير النشطة فقط',
    reset: 'إعادة تعيين',
    departmentsCount: 'الأقسام ({count})',
    noDepartments: 'لا توجد أقسام',
    noDepartmentsDesc: 'جرّب تعديل مرشحات البحث.',
    manager: 'المدير',
    employees: 'الموظفون',
    budget: 'الميزانية',
    workingHours: 'ساعات العمل',
    notAssigned: 'غير مُعيَّن',
    notSet: 'غير محدد',
    notConfigured: 'غير مُهيَّأ',
    active: 'نشط',
    inactive: 'غير نشط',
    edit: 'تعديل',
    deactivate: 'تعطيل',
    delete: 'حذف',
    addDepartmentTitle: 'إضافة قسم',
    editDepartmentTitle: 'تعديل القسم',
    name: 'اسم القسم',
    code: 'الرمز',
    descriptionLabel: 'الوصف',
    email: 'البريد الإلكتروني',
    phone: 'الهاتف',
    save: 'حفظ',
    cancel: 'إلغاء',
    confirmDelete: 'هل أنت متأكد من حذف أو تعطيل هذا القسم؟',
  },

  // ── Leave Types Management ────────────────────────────────────────────────
  leaveTypes: {
    title: 'أنواع الإجازات',
    description: 'تهيئة فئات الإجازات وقواعد الاستحقاق والسياسات',
    addLeaveType: 'إضافة نوع إجازة',
    search: 'بحث',
    searchPlaceholder: 'البحث في أنواع الإجازات…',
    status: 'الحالة',
    allTypes: 'جميع الأنواع',
    activeOnly: 'النشطة فقط',
    inactiveOnly: 'غير النشطة فقط',
    reset: 'إعادة تعيين',
    leaveTypesCount: 'أنواع الإجازات ({count})',
    noLeaveTypes: 'لا توجد أنواع إجازات',
    noLeaveTypesDesc: 'أضف نوع إجازة للبدء.',
    maxPerYear: 'الحد الأقصى / السنة',
    unlimited: 'غير محدود',
    carryForward: 'الترحيل',
    upTo: 'حتى {n} يوم',
    accrualRate: 'معدل الاستحقاق',
    manual: 'يدوي',
    totalRequests: 'إجمالي الطلبات',
    active: 'نشط',
    inactive: 'غير نشط',
    edit: 'تعديل',
    delete: 'حذف',
    days: 'أيام',
    dPerMonth: 'يوم/شهر',
    addLeaveTypeTitle: 'إضافة نوع إجازة',
    editLeaveTypeTitle: 'تعديل نوع الإجازة',
    name: 'الاسم',
    code: 'الرمز',
    color: 'اللون',
    descriptionLabel: 'الوصف',
    save: 'حفظ',
    cancel: 'إلغاء',
    confirmDelete: 'هل أنت متأكد من حذف نوع الإجازة هذا؟',
  },

  // ── Balance Banks Management ──────────────────────────────────────────────
  balanceBanks: {
    title: 'بنوك الأرصدة',
    description: 'إدارة مجمعات أرصدة الإجازات المشتركة وقواعد التخصيص',
    addBank: 'إضافة بنك رصيد',
    totalBanks: 'إجمالي البنوك',
    totalAllocated: 'إجمالي المخصص',
    totalUsed: 'إجمالي المستخدم',
    totalRemaining: 'إجمالي المتبقي',
    noBalanceBanks: 'لا توجد بنوك أرصدة',
    noBalanceBanksDesc: 'أنشئ أول بنك رصيد للبدء.',
    employees: 'الموظفون',
    allocated: 'المخصص',
    used: 'المستخدم',
    remaining: 'المتبقي',
    leaveTypes: 'أنواع الإجازات',
    usage: 'الاستخدام',
    system: 'نظام',
    edit: 'تعديل',
    delete: 'حذف',
    days: 'أيام',
    addBankTitle: 'إضافة بنك رصيد',
    editBankTitle: 'تعديل بنك الرصيد',
    tenureBased: 'بناءً على الخدمة',
    fixed: 'ثابت',
    flexible: 'مرن',
    save: 'حفظ',
    cancel: 'إلغاء',
    confirmDelete: 'هل أنت متأكد من حذف بنك الرصيد هذا؟',
  },

  // ── Leave Balance Management ──────────────────────────────────────────────
  leaveBalance: {
    title: 'إدارة أرصدة الإجازات',
    description: 'إدارة أرصدة إجازات الموظفين والسياسات',
    bulkUpdate: 'تحديث جماعي',
    leavePolicies: 'سياسات الإجازات',
    export: 'تصدير',
    manualEditInfo: 'تعديل الأيام المستخدمة يدوياً لأي بنك رصيد لأي موظف. تُحدَّث الأرصدة المتاحة تلقائياً وتُسجَّل في سجل التدقيق.',
    totalEmployees: 'إجمالي الموظفين',
    totalLeaveDays: 'إجمالي أيام الإجازة',
    usedLeaveDays: 'أيام الإجازة المستخدمة',
    lowBalance: 'رصيد منخفض',
    department: 'القسم',
    allDepartments: 'جميع الأقسام',
    leaveType: 'نوع الإجازة',
    allTypes: 'جميع الأنواع',
    balanceStatus: 'حالة الرصيد',
    allBalances: 'جميع الأرصدة',
    low: 'منخفض (أقل من 5 أيام)',
    medium: 'متوسط (5–15 يوم)',
    high: 'مرتفع (أكثر من 15 يوم)',
    applyFilters: 'تطبيق الفلاتر',
    reset: 'إعادة تعيين',
    employeeLeaveBalances: 'أرصدة إجازات الموظفين',
    searchPlaceholder: 'البحث عن موظفين…',
    noEmployees: 'لا يوجد موظفون',
    noEmployeesDesc: 'جرّب تعديل البحث أو الفلاتر.',
    employee: 'الموظف',
    allocated: 'المخصص',
    used: 'المستخدم',
    remaining: 'المتبقي',
    actions: 'الإجراءات',
    adjust: 'تعديل',
  },

  // ── Overtime Clock Management ─────────────────────────────────────────────
  overtimeClock: {
    title: 'إدارة ساعة العمل الإضافي',
    description: 'مراجعة وإدارة جلسات العمل الإضافي للموظفين',
    refresh: 'تحديث',
    pendingApproval: 'في انتظار الموافقة',
    activeSessions: 'الجلسات النشطة',
    needsReview: 'بحاجة مراجعة',
    pendingCost: 'التكلفة المعلقة',
    allClear: 'كل شيء على ما يرام!',
    nothingToReview: 'لا توجد جلسات تحتاج مراجعة في الوقت الحالي',
    noActiveSessions: 'لا توجد جلسات نشطة',
    noActiveSessionsDesc: 'لا توجد جلسات عمل إضافي نشطة حالياً',
    autoExpired: 'انتهت تلقائياً',
    clockIn: 'وقت الدخول',
    clockOut: 'وقت الخروج',
    timerEnds: 'ينتهي المؤقت',
    elapsed: 'الوقت المنقضي',
    estCost: 'التكلفة التقديرية',
    duration: 'المدة',
    rate: 'المعدل',
    anomalies: 'شذوذات',
    view: 'عرض',
    edit: 'تعديل',
    approve: 'موافقة',
    reject: 'رفض',
    forceClose: 'إغلاق إجباري',
    statusFilter: 'الحالة',
    allStatuses: 'جميع الحالات',
    pending: 'قيد الانتظار',
    active: 'نشط',
    underReview: 'قيد المراجعة',
    approved: 'موافق عليه',
    rejected: 'مرفوض',
    expired: 'منتهي',
    fromDate: 'من',
    toDate: 'إلى',
    clear: 'مسح',
    noRequests: 'لا توجد طلبات',
    employee: 'الموظف',
    type: 'النوع',
    status: 'الحالة',
    cost: 'التكلفة',
    page: 'صفحة',
    of: 'من',
  },

  // ── Overtime Management (Legacy) ──────────────────────────────────────────
  overtimeManagement: {
    title: 'إدارة العمل الإضافي',
    description: 'مراجعة والموافقة على طلبات العمل الإضافي للموظفين',
    bulkApprove: 'موافقة جماعية ({count})',
    bulkReject: 'رفض جماعي ({count})',
    export: 'تصدير',
    pendingRequests: 'الطلبات المعلقة',
    monthlyOvertime: 'العمل الإضافي هذا الشهر',
    overtimeCost: 'تكلفة العمل الإضافي',
    activeSessions: 'الجلسات النشطة',
    status: 'الحالة',
    allStatuses: 'جميع الحالات',
    department: 'القسم',
    allDepartments: 'جميع الأقسام',
    from: 'من',
    to: 'إلى',
    apply: 'تطبيق',
    overtimeRequests: 'طلبات العمل الإضافي',
    selectAll: 'تحديد الكل',
    noRequests: 'لا توجد طلبات عمل إضافي',
    ongoing: 'جارٍ',
    priority: 'أولوية',
    showing: 'عرض {from}–{to} من {total}',
    detailsTitle: 'تفاصيل طلب العمل الإضافي',
    employeeInfo: 'معلومات الموظف',
    requestDetails: 'تفاصيل الطلب',
    name: 'الاسم',
    department: 'القسم',
    employeeId: 'رقم الموظف',
    hourlyRate: 'الأجر بالساعة',
    date: 'التاريخ',
    expectedDuration: 'المدة المتوقعة',
    startTime: 'وقت البداية',
    mode: 'الوضع',
    type: 'النوع',
    preScheduled: 'مُجدوَل مسبقاً',
    realtimeClock: 'ساعة فورية',
    clockInLabel: 'وقت الدخول',
    clockOutLabel: 'وقت الخروج',
    clockOutMethod: 'طريقة الخروج',
    actualDuration: 'المدة الفعلية',
    estimatedCost: 'التكلفة التقديرية',
    actualCost: 'التكلفة الفعلية',
    manual: 'يدوي (الموظف)',
    autoCapped: 'محدود تلقائياً',
    adminForce: 'إغلاق إجباري من المدير',
    reasonLabel: 'السبب',
    approvalDecision: 'قرار الموافقة',
    notes: 'ملاحظات',
    notesPlaceholder: 'أضف أي ملاحظات أو شروط…',
    cancel: 'إلغاء',
    submitDecision: 'تأكيد القرار',
    submitting: 'جاري الإرسال…',
    bulkApproveTitle: 'موافقة جماعية على الطلبات',
    bulkApproveDesc: 'أنت على وشك الموافقة على {count} طلبات عمل إضافي.',
    bulkApprovalNotes: 'ملاحظات الموافقة الجماعية',
    bulkNotesPlaceholder: 'أضف ملاحظات لجميع الطلبات الموافق عليها…',
    approveAll: 'الموافقة على الكل',
    approving: 'جاري الموافقة…',
    bulkRejectTitle: 'رفض جماعي للطلبات',
    min: 'دقيقة',
    hr: 'ساعة',
  },

  // ── Reports (extended) ────────────────────────────────────────────────────
  reportsPage: {
    title: 'التقارير',
    subtitle: 'العمل الإضافي والحضور والإجازات والمغادرات والتأخير والرواتب، على الشاشة وبصيغة PDF أو Excel أو CSV.',
    reportType: 'التقرير',
    types: { overtime: 'العمل الإضافي', attendance: 'الحضور', leave: 'الإجازات', 'short-leave': 'المغادرات', 'late-arrivals': 'التأخير', payroll: 'الرواتب' },
    typeDesc: {
      overtime: 'الجلسات والساعات والتكلفة',
      attendance: 'السجل اليومي والغياب والساعات',
      leave: 'الطلبات والأرصدة والبنوك',
      'short-leave': 'المغادرات المبكرة وتغطيتها',
      'late-arrivals': 'دقائق التأخير والخصومات',
      payroll: 'تفاصيل الراتب الشهري',
    },
    scope: 'النطاق',
    scopes: { individual: 'موظف واحد', general: 'جميع الموظفين' },
    employee: 'الموظف',
    selectEmployee: 'اختر موظفاً…',
    period: 'الفترة',
    periods: { thisMonth: 'هذا الشهر', lastMonth: 'الشهر الماضي', thisQuarter: 'هذا الربع', thisYear: 'هذه السنة', lastYear: 'السنة الماضية', allTime: 'كل الفترات', custom: 'فترة مخصصة' },
    from: 'من',
    to: 'إلى',
    today: 'اليوم',
    emptyTitle: 'اختر تقريراً واضغط إنشاء',
    emptyBody: 'اختر نوع التقرير، موظفاً واحداً أو جميع الموظفين، والفترة. يظهر التقرير هنا ويمكن تنزيله بصيغة PDF أو Excel أو CSV.',
    failed: 'تعذر إنشاء التقرير',
  },
  reportsExt: {
    individualReport: 'تقرير فردي',
    individualDesc: 'سجلات مفصلة لموظف واحد',
    individualDetail: 'يعرض سجلات مفصلة تشمل أوقات الدخول/الخروج الفعلية وأسباب العمل الإضافي وتفاصيل الإجازات مع سجل التدقيق الكامل',
    generalReport: 'تقرير عام',
    generalDesc: 'بيانات مجمعة لجميع الموظفين',
    generalDetail: 'يعرض ملخصات على مستوى الفريق وتفاصيل الأقسام والتحليل المقارن بين الموظفين',
    selectDataType: 'اختر نوع البيانات',
    overtime: 'العمل الإضافي',
    overtimeDesc: 'ساعات الجلسة والتكاليف وحالة الموافقة',
    attendance: 'الحضور',
    attendanceDesc: 'سجلات الدخول/الخروج وساعات العمل',
    leave: 'الإجازات',
    leaveDesc: 'طلبات الإجازة والأرصدة والموافقات',
    shortLeave: 'الإجازة القصيرة',
    shortLeaveDesc: 'جلسات الإجازة في منتصف اليوم ومدتها',
    lateArrival: 'التأخر في الوصول',
    lateArrivalDesc: 'الحضور المتأخر ومبالغ الخصم',
    payroll: 'الرواتب',
    payrollDesc: 'تفاصيل الراتب وملخصات الخصومات',
    configureReport: 'تهيئة تقريرك',
    selectEmployee: 'اختر موظفاً',
    allEmployees: 'جميع الموظفين',
    dateRange: 'نطاق التاريخ',
    startDate: 'تاريخ البداية',
    endDate: 'تاريخ النهاية',
    generateReport: 'إنشاء تقرير',
    generating: 'جاري الإنشاء…',
    exporting: 'جاري التصدير…',
    pdfExported: 'تم تنزيل تقرير PDF',
    rateBasis: 'شهر أجر الساعة',
    rateBasisHint: 'اختياري: احتساب كل جلسة على أجر ساعة الموظف في راتب هذا الشهر. اتركه فارغاً لاستخدام التكلفة المسجلة.',
    exportPDF: 'تصدير PDF',
    exportExcel: 'تصدير Excel',
    exportCSV: 'تصدير CSV',
    reset: 'إعادة تعيين',
  },
}
